export default __webpack_public_path__ + "static/media/480_portfolio04-es-mobile.80309eeb.png";